import axios from "axios";
import { getAuthHeader } from "./authService";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/statistics`;

export type StatisticsPeriod = "1m" | "3m" | "6m" | "1y" | "ytd";

export type StatisticsOverview = {
  period: StatisticsPeriod;
  isPersonalView: boolean;
  sales: {
    magazineSignedRevenue: number;
    magazineSignedCount: number;
    eventOrderRevenue: number;
    eventOrderCount: number;
    orgMagazineSignedRevenue: number | null;
  };
  counts: {
    events: number;
    companies: number;
    contacts: number | null;
    exhibitors: number;
    orders: number;
    orderRevenue: number;
    publications: number;
    magazineBookings: number;
  };
  exhibitorByStatus: Record<string, number>;
  magazineByStatus: Record<string, number>;
  recent: {
    exhibitors: Array<{
      id: number;
      status: string;
      company: string;
      event: string;
      createdAt: string;
    }>;
    magazineBookings: Array<{
      id: number;
      status: string;
      company: string;
      detail: string;
      publication: string;
      salesRep: string;
      total: number;
      createdAt: string;
      href: string;
    }>;
    myMagazineBookings: Array<{
      id: number;
      status: string;
      company: string;
      detail: string;
      publication: string;
      salesRep: string;
      total: number;
      createdAt: string;
      href: string;
    }>;
  };
};

export const getStatisticsOverview = async (
  period: StatisticsPeriod = "1m"
): Promise<StatisticsOverview | null> => {
  try {
    const response = await axios.get(`${API_URL}/overview`, {
      headers: getAuthHeader(),
      params: { period },
    });
    return response.data;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};
